import { render, staticRenderFns } from "./RenovacionRapidaComponent.vue?vue&type=template&id=a97f6ed6&scoped=true"
import script from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionRapidaComponent.vue?vue&type=style&index=0&id=a97f6ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97f6ed6",
  null
  
)

export default component.exports